export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fotograf01-de.9ae6c7a5.png";